export const ULIVE_ADMIN_ENV_LOCALE_KEY = "api_base_url_env";

export const OPS_TOKEN_COOKIE_KEY = "Youpick-Ops-Token";
export const OPS_TH_TOKEN_COOKIE_KEY = "Youpik-Ops-th-Token";
export const OPS_VI_TOKEN_COOKIE_KEY = "Youpik-Ops-vn-Token";
